/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: voicemailsBroadcastGroupsActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Applications module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteBroadcastGroup } from './api/broadcastGroupsApi';

/**
 * Shared helpers for Voicemail Broadcast Groups module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a Voicemail Broadcast Group in the form.
 * Pattern: /pbx/applications/voicemail-broadcast/new?duplicate={id}
 */
export const getVoicemailBroadcastGroupDuplicateUrl = (id: string | number): string =>
  `/pbx/applications/voicemail-broadcast/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Voicemail Broadcast Group id.
 */
export const navigateToVoicemailBroadcastGroupDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getVoicemailBroadcastGroupDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a Voicemail Broadcast Group by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 */
export const deleteVoicemailBroadcastGroupById = async (id: string | number): Promise<void> => {
  await deleteBroadcastGroup(id);
};



